import { Icon } from '@eventbrite/eds-icon';
import { ChevronDownChunky, MapPinChunky } from '@eventbrite/eds-iconography';
import { Typography } from '@eventbrite/marmalade';
import loadable from '@loadable/component';
import React from 'react';
import { LocationAutocompleteContainer } from '../../../../containers/LocationAutocompleteContainer';
import classes from './CityBrowseBanner.module.scss';
import { CityBlurbProps, CityBrowseBannerProps } from './interface';

// Dynamically load CityBrowseBannerImage component
const CityBrowseBannerImage = loadable(
    () => import('./CityBrowseBannerImage'),
    {
        resolveComponent: (components: {
            CityBrowseBannerImage: React.ReactElement;
        }) => components.CityBrowseBannerImage,
    },
);

// Icon components
const ChevronIcon = (
    <Icon color="white" size="small" type={<ChevronDownChunky />} />
);
const LocationPin = <Icon type={<MapPinChunky />} color="white" size="small" />;

const CityBlurb = ({ cityBlurb }: CityBlurbProps) => {
    return (
        // using dangerouslySetInnerHtml because data from wagtail is written in HTML
        <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: cityBlurb.toString() }}
            data-spec="city-blurb"
            className={`${classes.cityBlurb} eds-text-bm eds-l-mar-vert-4`}
        />
    );
};

export const CityBrowseBanner = (props: CityBrowseBannerProps) => {
    const {
        cityBlurb,
        cityImage,
        citySmallImage,
        currentPlace,
        h1Prefix,
        handleUseCurrentLocation,
        handleLocationSelect,
        history,
        isBotRequest,
    } = props;

    const locationPicker = (
        <span
            className={classes.cityBrowseHeaderLocationAutocomplete}
            data-current-text={currentPlace}
            data-testid="city-browse-header"
            data-spec="location-autocomplete"
            style={
                {
                    '--character-count': currentPlace?.length || 10,
                } as any
            }
        >
            {isBotRequest ? (
                currentPlace
            ) : (
                <LocationAutocompleteContainer
                    handleUseCurrentLocation={handleUseCurrentLocation}
                    handleLocationSelect={handleLocationSelect}
                    suffix={ChevronIcon}
                    prefix={LocationPin}
                    history={history}
                    autocompleteProps={{
                        borderType: 'content',
                        preventInputValuePrefill: true,
                        id: 'browse-location-selector',
                    }}
                />
            )}
        </span>
    );

    return (
        <>
            <header className={classes.cityBrowseHeader}>
                <CityBrowseBannerImage
                    currentPlace={currentPlace}
                    cityImage={cityImage}
                    citySmallImage={citySmallImage}
                />
                <div className={classes.cityBrowseHeaderContent}>
                    <h1>
                        <Typography
                            variant="heading-md"
                            color="white"
                            className="headingPrefix"
                        >
                            {h1Prefix}
                        </Typography>
                        <Typography
                            variant="heading-lg"
                            color="white"
                            className="heading"
                        >
                            {currentPlace}
                        </Typography>
                    </h1>
                    <CityBlurb cityBlurb={cityBlurb || ''} />
                    {locationPicker}
                </div>
            </header>
            {locationPicker}
        </>
    );
};
